import { createAction } from 'redux-actions';
import * as types from './header-constants';

// eslint-disable-next-line
export const setMenuVisible = createAction(types.SET_MENU_VISIBLE);
